const MODES = {
  or: 'or',
  and: 'and',
} as const;

export default MODES;
